import { useMutation } from '@apollo/client'
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from '@mui/material'
import { ArchiveRoster } from 'recruiter/graphql/rosters.gql'
import useToast from 'shared/components/Toast/useToast'

import type {
    RosterProfileQuery,
    RosterProfileQueryVariables,
} from '__generated__/graphql'
import type { FC } from 'react'
import type { ApolloQueryRefetchFunction } from 'shared/types/graphql'

interface ArchiveRosterDialogProps {
    open: boolean
    onClose: () => void
    rosterId: string
    refetch: ApolloQueryRefetchFunction<
        RosterProfileQuery,
        RosterProfileQueryVariables
    >
}

const ArchiveRosterDialog: FC<ArchiveRosterDialogProps> = ({
    open,
    onClose,
    rosterId,
    refetch,
}) => {
    const toast = useToast()
    const [archiveRoster] = useMutation(ArchiveRoster, {
        onCompleted: (data) => {
            if (data.archiveRoster.success) {
                toast({
                    title: 'Success',
                    message: 'Search Archived Successfully',
                    severity: 'success',
                })
                refetch()
                onClose()
            } else {
                toast({
                    title: 'Error',
                    message:
                        data.archiveRoster.message ??
                        'Failed to archive search',
                    severity: 'error',
                })
            }
        },
        onError: (error) => {
            toast({
                title: 'Error',
                message:
                    error.message ?? 'Something went wrong, please try again',
                severity: 'error',
            })
        },
    })

    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="archive-dialog-title"
            aria-describedby="archive-dialog-description"
        >
            <DialogTitle id="archive-dialog-title">Archive Search</DialogTitle>
            <DialogContent>
                <DialogContentText id="archive-dialog-description">
                    Are you sure you want to archive this search?
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    Cancel
                </Button>
                <Button
                    onClick={() => {
                        archiveRoster({
                            variables: { rosterId },
                        })
                        onClose()
                    }}
                    color="primary"
                    autoFocus
                >
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default ArchiveRosterDialog
